import { render, staticRenderFns } from "./EntityTaxElection.vue?vue&type=template&id=79354099"
import script from "./EntityTaxElection.vue?vue&type=script&lang=ts"
export * from "./EntityTaxElection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports